import React from 'react';
import Heading from '../../../general/heading/heading.component';
import Card from '../../../general/card/card.component';
import Grid from '@mui/material/Grid';
import { finalList, CTC, company } from '../formEligibility/formEligibility.component';
import Button from '../../../general/button/button.component';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
let xlsx = require('json-as-xlsx');

const EligibleStudents = () => {
    
  const location = useLocation();
  const currentPath = location.pathname.substring(1,location.pathname.lastIndexOf('/')); //to get only the current path till student/faculty portal
  const BACKENDURL = 'https://placement-backend.vercel.app/api/mailSender';

  const handleSend = () => {

    let mailList = {
    list : [],
    company: company,
    CTC: CTC
    };
    finalList.forEach((item) => { mailList.list.push(item.email); });
    const MAILINGLIST = [];
    mailList.list.forEach((email)=>(MAILINGLIST.push({email : email})));
    mailList.list = MAILINGLIST;
    //push all email addresses to list array
    mailList = JSON.stringify(mailList);
    //stringify everything to send over to backend

    axios.post(BACKENDURL, mailList, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .then((response) => {
            console.log(response);
          }, (error) => {
            console.log(error);
          });
    //send over to backend, log response/error
  }

  const handleDownload = () => {

    let settings = {
      fileName: `EligibleStudents${company}_${CTC}lpa`, // Name of the resulting spreadsheet
      extraLength: 3, // A bigger number means that columns will be wider
    }
    //settings

    const xlsxContent = []; //to generate xlsx content array
    finalList.forEach((item) => {
      xlsxContent.push(
      {
      fullname : item.fullname,
      USN : item.USN,
      email : item.email,
      phone : item.phone,
      tenthper : item.tenthper,
      twelfthper : item.twelfthper,
      section : item.section,
      semester : item.semester,
      stream : item.stream
      }
      )
    });

    let data = [
      {
        sheet: 'Eligible Candidates',
        columns: [
          { label: 'Name', value: 'fullname' },
          { label: 'USN', value: 'USN' }, 
          { label: 'Email', value: 'email' },
          { label: 'Phone', value: 'phone' },
          { label: 'Tenth %', value: 'tenthper' }, 
          { label: 'Twelfth %', value: 'twelfthper' }, 
          { label: 'Section', value: 'section' }, 
          { label: 'Semester', value: 'semester' }, 
          { label: 'Stream', value: 'stream' }, 
        ],
        content: xlsxContent
      }
    ]
    //content

    xlsx(data, settings) 
    // Will download the excel file
  }

    return(
        <Grid container justifyContent="center" spacing={2}>
          <Grid item lg={12} md={12}>
            <br/> <br/> <br/>
            <Heading text={finalList.length!==0?'Eligible students':'There are no eligible students'} />
          </Grid>
          <Grid container spacing={4} justifyContent="center">
            {
            finalList.map((item) => (
              <Grid item justifyContent="center">
                <Grid item key={item.index}  lg={12} md={12} justifyContent="center">
                  <Card title={`${item.USN} | ${item.fullname}`} key={item.index} bigCardDisplay={true} content={`Phone : ${item.phone} | Email : ${item.email}`} linkTexts={[item.glassdoor,item.linkedin]} />
                </Grid>
              </Grid>
            ))
            }
          </Grid>
            <Grid container spacing={4} justifyContent="center">
              <Grid item justifyContent="center">
                <Grid item lg={12} md={12} justifyContent="center">
                  <br/> <br/>
                  <Button buttonLink={currentPath}>GO BACK</Button>
                </Grid>
              </Grid>
              {
                finalList.length!==0 ? 
                <Grid item justifyContent="center">
                  <Grid item lg={12} md={12} justifyContent="center">
                    <br/> <br/>
                    <Button onClick={ handleSend }>Send mail</Button>
                  </Grid>
                </Grid> 
                : null
              }
              {
                finalList.length!==0 ? 
                <Grid item justifyContent="center">
                  <Grid item lg={12} md={12} justifyContent="center">
                    <br/> <br/>
                    <Button onClick={ handleDownload }>Download xlsx</Button>
                  </Grid>
                </Grid> 
                : null
              }
          </Grid>
        </Grid>
    )
}

export default EligibleStudents;